export var ApplicationName;
(function (ApplicationName) {
    ApplicationName["mytennights"] = "mytennights";
    ApplicationName["mytendays"] = "mytendays";
    ApplicationName["myfridays"] = "myfridays";
    ApplicationName["evergive"] = "evergive";
    ApplicationName["charity"] = "charity";
    ApplicationName["givematch"] = "givematch";
    ApplicationName["admin"] = "admin";
    ApplicationName["customerService"] = "customerservice";
})(ApplicationName || (ApplicationName = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXBwbGljYXRpb25OYW1lLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbImNvbW1vbi9BcHBsaWNhdGlvbk5hbWUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxDQUFOLElBQVksZUFTWDtBQVRELFdBQVksZUFBZTtJQUN6Qiw4Q0FBMkIsQ0FBQTtJQUMzQiwwQ0FBdUIsQ0FBQTtJQUN2QiwwQ0FBdUIsQ0FBQTtJQUN2Qix3Q0FBcUIsQ0FBQTtJQUNyQixzQ0FBbUIsQ0FBQTtJQUNuQiwwQ0FBdUIsQ0FBQTtJQUN2QixrQ0FBZSxDQUFBO0lBQ2Ysc0RBQW1DLENBQUE7QUFDckMsQ0FBQyxFQVRXLGVBQWUsS0FBZixlQUFlLFFBUzFCIn0=